import { render, staticRenderFns } from "./MinorLanguages.vue?vue&type=template&id=489d296d&scoped=true"
import script from "./MinorLanguages.vue?vue&type=script&lang=js"
export * from "./MinorLanguages.vue?vue&type=script&lang=js"
import style0 from "./MinorLanguages.vue?vue&type=style&index=0&id=489d296d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489d296d",
  null
  
)

export default component.exports